import React, { useId } from 'react';
import styles from './Checkbox.module.css';

type CheckboxProps = {
    label?: string;
    checked?: boolean;
    onChange?: (val: boolean) => void;
    disabled?: boolean;
    required?: boolean;
    variant?: 'default' | 'button';
    additionalText?: string;
    id?: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
    label = '',
    checked = false,
    onChange = () => {},
    disabled = false,
    required = false,
    variant = 'default',
    additionalText,
    id
}) => {
    const generatedId = useId();
    const checkboxId = id || `checkbox-${generatedId}`;
    const handleChange = () => {
        if (!disabled) onChange(!checked);
    };
    return (
        <div className={styles.checkboxContainer}>
            <input type="checkbox" checked={checked} onChange={handleChange} disabled={disabled} className={styles.input} id={checkboxId} />
            <label
                htmlFor={checkboxId}
                className={`${styles.label} ${additionalText ? styles.additionalTextt : ''} ${disabled ? styles.disabledLabel : ''} ${variant === 'button' ? styles.buttonLabel : ''} ${checked ? styles.checked : ''}`}
            >
                {variant === 'default' && <span className={`${styles.checkmark} ${checked ? styles.checkedMark : ''}`}></span>}
                <span className={styles.labelText}>{label}</span>
                {additionalText && <span className={styles.additionalText}>{additionalText}</span>}
                {required && <span className={styles.required}>*</span>}
            </label>
        </div>
    );
};

export default Checkbox;
